import { render, staticRenderFns } from "./xianZhi.vue?vue&type=template&id=81d81dea&scoped=true&"
import script from "./xianZhi.vue?vue&type=script&lang=js&"
export * from "./xianZhi.vue?vue&type=script&lang=js&"
import style0 from "./xianZhi.vue?vue&type=style&index=0&id=81d81dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d81dea",
  null
  
)

export default component.exports